export default __webpack_public_path__ + "static/media/Bengali_bm_2.bc94887b.mp3";